//Header scoroll
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
     //>=, not <=
    if (scroll >= 500) {
        //clearHeader, not clearheader - caps H
        $(".header_wrapper").addClass("pinned");
    }else{
      $(".header_wrapper").removeClass("pinned");
    }

    if (document.querySelector('.flavor_sidebar_button')) {
      if ($(document).scrollTop() + 400 >= $('.flavor_wrapper').offset().top) {
        console.log($('.flavor_wrapper').offset().top)
        $('.flavor_sidebar_button').addClass('visible');
      } else {
        $('.flavor_sidebar_button').removeClass('visible');
      }
    }
}); //missing );

/*Open Menu*/
$(".menu-button").on('click', function() {
  if($(this).hasClass('is-active')){
      $("html").css('overflow-y','scroll');
      $(this).removeClass('is-active');
      $('.header_center').removeClass('is-active');
      // $('.mobile_menu').removeClass('openmenu');
    }
    else{
      $(this).addClass('is-active');
      jQuery("html").css('overflow-y','hidden');
      $('.header_center').addClass('is-active');
      // $('.mobile_menu').addClass('openmenu');
  }
});




/*Hover Menu - Add Class to all except hover item*/
// $(document).ready(function() {
//   $('#menu-main-menu li a').hover(function() {
//     $('#menu-main-menu li a').not($(this)).addClass('not-hovered');
//   }, function() {
//     $('#menu-main-menu li a').removeClass('not-hovered');
//   });
// });

/*Custom Tabs*/
$("#custom_tabs .tabs p").on('click', function () {
  var tab_open;
  var content_open;
  if($(this).hasClass('active')){

  }else{
    $("#custom_tabs .tabs p").removeClass('active');
    $(this).addClass('active');
    tab_open=$(this).attr("data-tab");
  }
  $( ".tab_content .content" ).each(function( index ) {
      content_open=$(this).attr("data-tab");
      if(content_open == tab_open){
        $( ".tab_content .content" ).removeClass('active');
        $(this).addClass('active');
      }
  });
});


/*Add animation on page load to h1*/
$(document).ready(function () {
  setTimeout(function () {
    $('h1').addClass('is-visible');
  }, 200);
});


/* Default slider swipper */
//import Swiper, { Navigation , Pagination } from 'swiper';

if($("#icecream").length){
    var mySwiper = new Swiper(".icecream_swipe", {
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 5.5,
        speed: 800,
        effect: "creative",
        creativeEffect: {
            perspective: true,
            limitProgress: 5.5,
            prev: {
                translate: ['-75%', '20%', -100],
                rotate: [0, 0, -20],
                origin: "bottom"
            },
            next: {
                translate: ['75%', '20%', -100],
                rotate: [0, 0, 20],
                origin: "bottom"
            },
        },
        breakpoints: {
            769: { slidesPerView: 3 },
            0:   { slidesPerView: 1.5 },
        },
    });
};



    $( ".menu li" ).each(function( index ) {
      $(this).append("<svg viewBox='0 0 500 150' preserveAspectRatio='none'><path fill='none' d='M325,18C228.7-8.3,118.5,8.3,78,21C22.4,38.4,4.6,54.6,5.6,77.6c1.4,32.4,52.2,54,142.6,63.7 c66.2,7.1,212.2,7.5,273.5-8.3c64.4-16.6,104.3-57.6,33.8-98.2C386.7-4.9,179.4-1.4,126.3,20.7'/></svg>")
    });

    /*change background*/
    $(window).on('scroll', function() {
        $('.flavors').each(function() {
            if ($(this).hasClass('aos-animate')) {
                var color = $(this).attr('data-color');
                $('#flavors').css('background-color', color);
            }
        });
    });

    if ($(".flavor_sidebar p")) {
      $(".flavor_sidebar p").on('click', function () {
          var clickto=$(this).attr('data-id');
          $('html, body').animate({
              scrollTop: $('#'+clickto).offset().top - 100 }, 2000);
      });
    }
    
document.addEventListener('DOMContentLoaded', function () {
  var cardSwiper = new Swiper(".swiper.cards_swiper_container", {
    direction: 'vertical',
    effect: 'cards',
    grabCursor: true,
    loop: true,
    navigation: {
      nextEl: '.card-swiper-button-next',
      prevEl: '.card-swiper-button-prev',
    },
  });
});
